import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { HammerModule } from '@angular/platform-browser';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { GlobalVariables } from './data/global-variables';
import { FloatingVisorComponent } from './floating-visor/floating-visor.component';
import { CornerstoneLiteDirective } from './floating-visor/cornerstone-lite.directive';
import { BookPdfFlipbookComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook.component';
import { CheckAccessComponent } from './tabs/check-access/check-access.component';
import { AnimationsComponent } from './utils/animations/animations.component';
import { ShareStudyComponent } from './utils/share-study/share-study.component';
import { AlertComponent } from './utils/alert/alert.component';
import { DownloadInstructionsComponent } from './utils/download-instructions/download-instructions.component';
import { VisorContextMenuComponent } from './utils/visor-context-menu/visor-context-menu.component';
import { AuthTokenInterceptor } from './auth/auth-token.interceptor';
import { BookPdfFlipbookVerticalComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-vertical/book-pdf-flipbook-vertical.component';
import { BookPdfFlipbookLandscapeComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook-landscape/book-pdf-flipbook-landscape.component';
import { SideOptionsDesktopComponent } from './utils/side-options-desktop/side-options-desktop.component';
import { SideOptionsMobileComponent } from './utils/side-options-mobile/side-options-mobile.component';
import { ContactImageComponent } from './utils/contact-image/contact-image.component';
import { HistoricDemoComponent } from './demo/historic-demo/historic-demo.component';
import { SeriesScrollbarComponent } from './floating-visor/series-scrollbar/series-scrollbar.component';
import { FloatingTipsComponent } from './floating-tips/floating-tips.component';
import { CookieService } from 'ngx-cookie-service';
import { AccessLocatorComponent } from './tabs/access-locator/access-locator.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';
import { DownloadModalComponent } from './utils/download-modal/download-modal.component';
import { DownloadModalMobileComponent } from './utils/download-modal/download-modal-mobile/download-modal-mobile.component';
import { ShareStudyMobileComponent } from './utils/share-study/share-study-mobile/share-study-mobile.component';
import { InfoStudyComponent } from './utils/info-study/info-study.component';
import { QRCodeModule } from 'angularx-qrcode';
import { AiReportComponent } from './utils/ai-report/ai-report.component';
import { HistoricalModalMobileComponent } from './utils/historical-modal-mobile/historical-modal-mobile.component';
import { RecoverMailComponent } from './tabs/recover-mail/recover-mail.component';


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FloatingVisorComponent,
    CornerstoneLiteDirective,
    BookPdfFlipbookComponent,
    CheckAccessComponent,
    AnimationsComponent,
    ShareStudyComponent,
    AlertComponent,
    DownloadInstructionsComponent,
    VisorContextMenuComponent,
    BookPdfFlipbookVerticalComponent,
    BookPdfFlipbookLandscapeComponent,
    SideOptionsDesktopComponent,
    SideOptionsMobileComponent,
    ContactImageComponent,
    HistoricDemoComponent,
    SeriesScrollbarComponent,
    FloatingTipsComponent,
    AccessLocatorComponent,
    DownloadModalComponent,
    DownloadModalMobileComponent,
    ShareStudyMobileComponent,
    InfoStudyComponent,
    AiReportComponent,
    HistoricalModalMobileComponent,
    RecoverMailComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    HammerModule,
    PdfViewerModule,
    QRCodeModule ,
    TranslateModule.forRoot({
      defaultLanguage: 'es',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      }
    })
  ],
  providers: [
    GlobalVariables,
    { provide: HTTP_INTERCEPTORS, useClass: AuthTokenInterceptor, multi: true },
    CookieService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }